import {
	HANDED_OVER_PARTNER_KEY_SESSION_STORAGE,
	USER_PARTNER_ID_KEY_SESSION_STORAGE,
	USER_PARTNER_NAME_KEY_SESSION_STORAGE,
} from "@constants/constants";

export const partnerIdInstance = {
	setPartnerId: (partnerId: string) =>
		sessionStorage.setItem(USER_PARTNER_ID_KEY_SESSION_STORAGE, partnerId),
	getPartnerId: () => {
		const partnerId = sessionStorage.getItem(
			USER_PARTNER_ID_KEY_SESSION_STORAGE,
		);

		return partnerId;
	},
	// The scoring service authorises a request against the partner's name, which
	// only identity knows, so it is kept next to the id the requests are built
	// from — see the `partner` parameter in `shared/api/requests.ts`.
	setPartnerName: (partnerName: string) =>
		sessionStorage.setItem(USER_PARTNER_NAME_KEY_SESSION_STORAGE, partnerName),
	getPartnerName: () =>
		sessionStorage.getItem(USER_PARTNER_NAME_KEY_SESSION_STORAGE),
	// The organization another zypl app handed the user over in, by name. Kept
	// apart from the name above, which goes out with every request: this one
	// is unchecked until the session check finds it among the user's partners.
	setHandedOverPartner: (partnerName: string) =>
		sessionStorage.setItem(
			HANDED_OVER_PARTNER_KEY_SESSION_STORAGE,
			partnerName,
		),
	/** Reads the handed-over name once; it is gone after this. */
	takeHandedOverPartner: () => {
		const partnerName = sessionStorage.getItem(
			HANDED_OVER_PARTNER_KEY_SESSION_STORAGE,
		);
		sessionStorage.removeItem(HANDED_OVER_PARTNER_KEY_SESSION_STORAGE);

		return partnerName;
	},
	clearPartnerId: () => {
		sessionStorage.removeItem(USER_PARTNER_ID_KEY_SESSION_STORAGE);
		sessionStorage.removeItem(USER_PARTNER_NAME_KEY_SESSION_STORAGE);
	},
};
